import { render, staticRenderFns } from "./Promotion_audit.vue?vue&type=template&id=08e1599b&"
import script from "./Promotion_audit.vue?vue&type=script&lang=js&"
export * from "./Promotion_audit.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_audit.vue?vue&type=style&index=0&id=08e1599b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports